<template>
  <div>
    <!-- 
      Form Pay Bet
    -->
    <v-card class="py-4">
      <div style="max-width: 600px; margin: 0 auto">
        <v-form ref="form" v-model="valid" :lazy-validation="lazy">
          <v-card-text class="pb-0">
            <div class="pb-4 subtitle-1">{{ $t("digitCodeBet") }}</div>
            <v-alert v-model="alert" type="warning" text outlined dismissible>{{
              alertMsg
            }}</v-alert>
            <v-text-field
              solo-inverted
              v-model="codBet"
              :rules="[codBetRulesRequired, codBetRulesValid]"
              :label="$t('code')"
              required
              clearable
              hide-details
              autofocus
            ></v-text-field>
          </v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn
              depressed
              color="info"
              :loading="loading"
              type="submit"
              :disabled="!valid"
              @click.prevent="validate"
              >{{ $t("next") }}
            </v-btn>
          </v-card-actions>
        </v-form>
      </div>
    </v-card>

    <!-- 
      Diaglog > BetCard
    -->
    <v-dialog
      v-model="dialog"
      scrollable
      max-width="600px"
      :fullscreen="this.$vuetify.breakpoint.xsOnly"
      light
    >
      <v-card>
        <v-toolbar max-height="64" elevation="0" class="transparent">
          <v-toolbar-title>{{ $t("payBet") }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-divider></v-divider>

        <v-card-text style="height: auto" class="pa-2 grey darken-3">
          <!-- 
          Alert Awarded
          -->
          <v-alert
            v-model="alertAwarded"
            :type="alertAwardedColor"
            text
            outlined
            class="my-2 mt-0"
            >{{ alertAwardedMsg }}</v-alert
          >
          <!-- 
            Component BetCard 
          -->
          <BetCard />
        </v-card-text>
        <v-divider></v-divider>
        <v-form
          class="ma-4"
          ref="form1"
          v-model="valid1"
          :lazy-validation="lazy"
        >
          <div v-if="!disabledForm1">
            <div class="pb-4 subtitle-1">{{ $t("enterTheHashCode") }}</div>
            <v-text-field
              outlined
              v-model="codBetHash"
              :rules="[codBetRulesRequired, codBetHashRules]"
              :label="$t('hashCode')"
              required
              clearable
            ></v-text-field>
          </div>

          <v-card-actions class="pa-0">
            <v-spacer></v-spacer>
            <v-btn text @click="dialog = false">{{ $t("BtnCancel") }} </v-btn>
            <template v-if="!disabledForm1">
              <v-btn
                depressed
                color="success"
                :disabled="!valid1"
                :loading="loading2"
                @click="confirmPay"
                >{{ $t("confirmPayment") }}
              </v-btn>
            </template>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import BetCard from "@/components/agent/Backoffice/bet/BetCard";
export default {
  name: "ViewAgentBetPay",
  components: {
    BetCard,
  },
  data: () => ({
    valid: true,
    valid1: true,
    loading: false,
    loading2: false,
    disabledForm1: true,
    codBet: "",
    codBetHash: "",
    dialog: false,
    // codBetRules: [
    //   (v) => !!v || "Campo obrigatório",
    //   (v) => /^\d+$/.test(v) || "Digite um código válido", // only number
    // ],
    // codBetHashRules: [
    //   (v) => !!v || "Campo obrigatório",
    //   (v) => (v && v.length == 10) || "Digite uma código válido",
    // ],
    lazy: false,
    betData: "",
    alert: false,
    alertMsg: "",
    alertAwarded: true,
    alertAwardedColor: "",
    alertAwardedMsg: "",
  }),

  computed: {
    codBetRulesRequired() {
      return (v) => !!v || this.$t("requiredInput");
    },
    codBetRulesValid() {
      return (v) => /^\d+$/.test(v) || this.$t("validCode");
    },
    codBetHashRules() {
      return (v) => (v && v.length == 10) || this.$t("validCode");
    },
  },

  methods: {
    // Validate Pay Bet Flow
    // 1. getBetAgent - Open Dialog to confirm pay bet;
    // Important: required 'printed: 0'
    validate() {
      if (this.$refs.form.validate()) {
        this.$store.commit("setFeedbackProgress", true);
        this.loading = true;
        const params = {
          id_bet: this.codBet,
          printed: 0,
        };

        this.$axios
          .post("agent/bets/getBetAgent", this.$formdata(params))
          .then((resp) => {
            if (resp.status === 200) {
              this.betData = resp.data.dados[0];
              // Open Bet Card:
              this.dialog = true;
              this.$store.commit("setBetCard", this.betData);
              // Check Winning Bet
              this.checkWinningBet(this.betData);
            }
          })
          .catch((err) => {
            if (err.response.data.status === 400) {
              // alert static
              this.alert = true;
              this.alertMsg = err.response.data.messages.error;
            }
          })
          .finally(() => (this.loading = false));
      }
    },

    // CheckBet
    checkWinningBet(bet) {
      // Se o result_bet for igual 1 a aposta é premiada.

      if (bet.result_bet != "1") {
        this.disabledForm1 = true;
        this.alertAwardedColor = "warning";
        this.alertAwardedMsg = this.$t("statusBetDoesntWin");
        return;
      }

      // aposta premiada;
      this.disabledForm1 = false;
      this.alertAwardedColor = "info";
      this.alertAwardedMsg = this.$t("statusBetWonConfirmToPay");
    },

    // 2. Confirm Pay
    confirmPay() {
      if (this.$refs.form1.validate()) {
        this.$store.commit("setFeedbackProgress", true);
        this.loading2 = true;

        const params = {
          id_bet: this.codBet,
          hash: this.codBetHash,
        };

        this.$axios
          .post("agent/bets/paidBet", this.$formdata(params))
          .then((resp) => {
            if (resp.status === 200) {
              this.dialog = false;

              // FeedBack Dialog Success!
              this.$store.commit("setFeedbackDialog", {
                title: this.$t("betCode") + this.codBet + this.$t("betPaid"),
                msg: resp.data.messages,
                shareBetPDF: false,
                type: "success",
                // action: "printer",
              });
              this.$store.commit("setCash", resp.data.credit_current);
              this.$refs.form.reset();
            }
          })
          .catch((err) => {
            if (err.response.data.status === 400) {
              this.dialog = false;
              // alert static
              this.alert = true;
              this.alertMsg = err.response.data.messages.error;
            }
          })
          .finally(() => (this.loading2 = false));
      }
    },
  },
};
</script>
